import React from "react"
import BibleForce from "../Components/BibleForce/BibleForce"
import {globals} from "../Components/Globals/Globals"
import NestedTitlePicture from '../Components/NestedTitlePicture/NestedTitlePicture';
import RestranscripteursPicture from '../assets/home/thonon_home_picture.jpeg';

const BiblePageView = () => {
    return(
        <div className="view-container">
            {/* Full width main picture */}
            <NestedTitlePicture 
                width="100%"
                height="350px"
                pictureTitle={globals.menu.bible_read}
                pictureURL={RestranscripteursPicture}
                color="white"
                fontSize="3em"
            />
            <div className="body-page-container">
                {/* Laïus introduction de la page*/}
                <div className="welcome-title">
                    <div>
                        Etudions ensemble la Parole de Dieu…
                    </div>
                </div>

                <div className='bible-container'>
                    <BibleForce/>
                </div>                
            </div>
        </div>
    )
}

export default BiblePageView;